var document = require('./_global').document;
module.exports = document && document.documentElement;



//////////////////
// WEBPACK FOOTER
// ./~/gatsby-plugin-react-next/~/core-js/modules/_html.js
// module id = ./node_modules/gatsby-plugin-react-next/node_modules/core-js/modules/_html.js
// module chunks = 168707334958949